import React from 'react';
import { ArrayHelpers, Loading, Paging } from '@salesperformanceint/e4shared';
import BlobImage from 'components/blobImage';
import Toggle from 'components/prism/toggle';
import Subheader from 'components/prism/subheader';

export const Leaderboard = ({ text, data, period, setPeriod, loading }) => {
    const pageSize = 10;
    const [page, setPage] = React.useState(1);

    const extra = (
        <Toggle value={period} onChange={setPeriod}>
            <button value="M">{text.month}</button>
            <button value="Q">{text.quarter}</button>
            <button value="Y">{text.year}</button>
            <button value="">{text.allTime}</button>
        </Toggle>
    );

    return (
        <div>
            <div className="mb10">
                <Subheader title={text.title} extra={extra} />
            </div>
            <div className="prism-content-box">
                {loading ? (
                    <Loading />
                ) : (
                    <div className="prism-content-hover text-600">
                        {ArrayHelpers.getPage(data, page, pageSize).map((item, i) => {
                            return (
                                <div key={`item-${item.id}`} className="flex flex-center">
                                    <div className="mr10 text-right" style={{ width: '20px' }}>
                                        {(page - 1) * pageSize + 1 + i}.
                                    </div>
                                    <BlobImage
                                        folder="avatar"
                                        src={item.avatar}
                                        width="25"
                                        height="25"
                                        initials={item.initials}
                                        className="img-circle"
                                    />
                                    <div className="ml10">{item.full_Name}</div>
                                    <div className="flex-grow text-right">{item.value}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            {!loading && data.length > pageSize && (
                <div className="mt10 text-center welcome-paging">
                    <Paging recordCount={data.length} page={page} pageSize={pageSize} goToPage={setPage} />
                </div>
            )}
        </div>
    );
};

export default Leaderboard;
